
export default function Playup() {
  return (
    <div className="h-screen w-full flex flex-col overflow-hidden">

      <div className="flex-1 overflow-hidden">
        <iframe
          src="https://playup.id/contact"
          title="Playup Contact"
          className="w-full h-full border-0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          loading="lazy"
        />
      </div>
    </div>
  );
}

